import MenuUser from './menuUser'

const menuUser = new MenuUser()
menuUser.init()
